    <div class="container-fluid page-content">

        <div class="row">
            <div class="col">
                <label class="title">Usuarios</label>
            </div>
        </div>

        <div class="row">
            <div class="col text-end">
                <button (click)="abrirModalCrearUsuario()" class="btn btn-sm btn-success rounded-button">
                    <i class="fas fa-plus"></i>&nbsp;
                    Nuevo usuario
                </button>
            </div>
        </div>

        <div class="row mt-3">
            <p-table #dt [value]="listaUsuarios" [scrollable]="true" [scrollHeight]="'calc(100vh - 260px)'" [paginator]="true" [rows]="20" [showCurrentPageReport]="true" currentPageReportTemplate="Mostrando {first} a {last} de {totalRecords}" [rowsPerPageOptions]="[20,50,100,200]">

                <ng-template pTemplate="header">
                    <tr>
                        <th pSortableColumn="usuario" class="medium-col" style="border-top-left-radius: 15px;">No. de empleado</th>
                        <th pSortableColumn="nombre" class="medium-col">Nombre(s)</th>
                        <th pSortableColumn="apellidoPaterno" class="medium-col">Apellido paterno</th>
                        <th pSortableColumn="apellidoMaterno" class="medium-col">Apellido materno</th>
                        <th pSortableColumn="rol" class="medium-col">Rol</th>
                        <th pSortableColumn="IATA" class="medium-col">Estación</th>
                        <th class="medium-col" style="border-top-right-radius: 15px;">Accion</th>
                    </tr>

                    <tr class="filter-row">
                        <th>
                            <input placeholder="Flitrar" type="text" #filtroNoEmpleado class="form-input form-input-table-filter" (input)="dt.filter(filtroNoEmpleado.value, 'usuario', 'contains')">
                        </th>

                        <th class="filter-row">
                            <input placeholder="Filtrar" #filtroNombre type="text" class="form-input form-input-table-filter" (input)="dt.filter(filtroNombre.value, 'nombre', 'contains')">

                        </th>
                        <th class="filter-row">
                            <input placeholder="Filtrar" #filtroPaterno type="text" class="form-input form-input-table-filter" (input)="dt.filter(filtroPaterno.value, 'apellidoPaterno', 'contains')">
                        </th>

                        <th class="filter-row">
                            <input placeholder="Filtrar" #filtroMaterno type="text" class="form-input form-input-table-filter" (input)="dt.filter(filtroMaterno.value, 'apellidoMaterno', 'contains')">
                        </th>
                        <th class="filter-row">
                            <input placeholder="Filtrar" #filtroRol type="text" class="form-input form-input-table-filter" (input)="dt.filter(filtroRol.value, 'rol', 'contains')">

                        </th>
                        <th class="filter-row">
                            <input placeholder="Filtrar" #filtroEstacion type="text" class="form-input form-input-table-filter" (input)="dt.filter(filtroEstacion.value, 'IATA', 'contains')">
                        </th>

                        <th></th>
                    </tr>
                </ng-template>

                <ng-template pTemplate="body" class="animated fadeIn fast" let-usuario>
                    <tr>
                        <td class="medium-col">{{ usuario.usuario }}</td>
                        <td class="medium-col">{{usuario.nombre}}</td>
                        <td class="medium-col">{{usuario.apellidoPaterno}}</td>
                        <td class="medium-col">{{usuario.apellidoMaterno}}</td>
                        <td class="medium-col">{{usuario.rol}}</td>
                        <td class="medium-col">{{usuario.IATA}}</td>
                        <td class="medium-col">
                            <button type="button" (click)="abrirModalEditarUsuario(usuario)" style="font-size:12px; width: 100px;" class="btn btn-xs my-button-blue-outline rounded-button">
                                <i class="far fa-edit"></i>&nbsp;
                                Editar
                            </button>
                        </td>
                    </tr>
                </ng-template>
            </p-table>

        </div>

    </div>